<div class="club-points">
  <span>{{ $t('my_account.the_club.beauty_points_member_info_app') }}</span>: <strong>{{ $t('my_account.the_club.beauty_points_count_formatted', { count: cart?.club_points }) }}</strong>
</div>
